<template>
<mu-dialog :open = 'true' dialogClass = 'dialog-class train-plan-wrap' bodyClass="train-plan-body">
  <div style = ' height: 100%;  display: flex; flex-direction: column;'>
    <trainMenu  ref="trainmenu" :trainCategories='trainCategories' :isModal = "isModal" @category-path-updated = 'onTrainCategoryChoose'/>
    <div style = 'padding-left:40px; height: 420px; overflow-y: auto;'>
      <mu-circular-progress v-if="fetchGame" class="demo-circular-progress" style="position:absolute;left:50%;top:50%;" :stroke-width="5" :size="48"></mu-circular-progress>
      <div v-if="noTrain" class="no-train">更多训练敬请期待</div>
      <card-list v-if="!fetchGame" :isModal = "isModal" :listItems = 'currentTrainCategory ? sortGame(currentTrainCategory.games) : []' :itemComponent = 'trainCard' @list-item-clicked = 'onTrainClicked'/>
    </div>
    <div style = 'height: 30px;'>
    </div>
  </div>
  <div style="position:absolute; bottom:0; right:0; background-color:#fff; display: flex; flex-direction: row; align-items: center; justify-content: flex-end; padding-bottom: 10px;">
    <mu-raised-button  label  = "取消" style  = "backgroundColor: #ddd;" @click = "cancelhandler"/>
    <div style="width: 40px;"/>
    <mu-raised-button  primary  :label= "`确定 (${len})`" :disabled = "len === 0" @click = "confirmHandler(checkItem)"/>
    <div style="width: 40px;"/>
  </div>
</mu-dialog>
</template>
<script>
  import Vue             from 'vue'
  import {removeByValue} from '../../../../assets/js/common.js'
  import bz_utils        from '../../../common/tree/utils'
  import CardList        from '../../../../foundation/ui/controls/card-list';
  import trainMenu       from '../../../common/trainMenu.vue'
  import level           from '../../../common/levels.vue'
  import TrainListItem   from '../../../bz/train-card';
  export default ({
    // 获取父级数据
    props: {
      //用于显示弹框的title
      title: {
        type: String,
        default: ''
      },
      //已经选择的训练方案
      games: {
          type: Array,
          default: function(){
              return []
          }
      },
      //请求的接口
      url: String
    },
    computed: {
      //当前选中的游戏项数
      itemLength: function(){
        return '确认 (' + this.checkItem.length + ')';
      }
    },
    data() {
      return {
        address: GLOBAL.cognition,
        showLoading: false,
        //选中的游戏
        checkItem:[],
        oneGrade: '',
        twoGrade: '',
        trainList: [],
        disabled: true,
        showDialog: false,
        trainCategories: bz_utils.buildTrainCategoryTree(),
        currentTrainCategory: null,
        trains: null,
        trainCard: TrainListItem,
        selectedGames: {},
        isModal:true,
        fetchGame:true,
        count:0,
        noTrain:false,
        len:0,
      }
    },
    components:{
      trainMenu,
      level,
      'card-list': CardList,
    },
    mounted() {
      // this.fetch();
      // console.log(bz_utils.buildTrainCategoryTree());
    },
    methods: {
      show: function()
      {
        this.trains = null;
        this.selectedGames = {};
        this.showDialog = true;
      },
      close: function(ev)
      {
        this.$emit("closeModal");
      },
      onTrainClicked: function(ev)
      {
        let game = ev.itemData;
        console.log(ev)
        if (game.selected)
        {
          game.selected = false;
        }
        else
        {
          game.selected = true;
        }
        ev.item.$forceUpdate();
        this.$forceUpdate();
        this.len = Object.values(this.selectedGames).length;
      },
      sortGame: function(games){
        var arr = [];
        var obj = {}; //去重
        if(this.count > 0){
          this.trains.forEach((item)=>{
            games.forEach((game)=>{
              if(game.id == item.id){
                arr.push(game);
              }
            })
          })
        }
        arr = arr.reduce((cur,next) => {
          obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
          return cur;
        },[]);
        return arr;
      },
      onTrainCategoryChoose: function(categoryPath)
      {
        this.noTrain = false;
        if(categoryPath.length > 1 && categoryPath.slice(-1)[0].games.length == 0 && !this.noContent){
          this.noTrain = true;
        }
        var self = this;
        let cat = categoryPath.slice(-1)[0];
        this.currentTrainCategory = cat;
        if (this.trains === null)
        {
          Vue.http({
            method: 'GET',
            url: '/api/Game/getAllGames',
          }).then(resp=>{
            let selection = self.selectedGames;
            let gamesInPlan = {};

            self.games.forEach(x=>gamesInPlan[x.id] = x);
            let flat_games = 
              bz_utils.canonicalizeGames(resp.data.data)
                .filter(x=>(x.id in gamesInPlan) === false);
            flat_games.forEach(x=>
            {
              Object.defineProperty(x, 'selected', {
                get: function()
                {
                  return (this.id in selection);
                },
                set: function(val)
                {
                  if (true === val)
                  {
                    selection[this.id] = this;
                  }
                  else
                  {
                    delete selection[this.id];
                  }
                },
              });
            });
            self.trainCategories.resetGames(flat_games);
            self.trains = flat_games;
            self.fetchGame = false;
            self.count ++;
          })
        }
      },
      //取消按钮
      cancelhandler(){
        this.close();
      },
      //确认按钮
      confirmHandler(checkItem){
        this.close();
        console.log(Object.values(this.selectedGames));
        this.$emit('submitData', Object.values(this.selectedGames));
        $(".right-content").css("overflow","auto");
      }
    },
    beforeDestroy(){
      this.checkItem.forEach(function(item, index){
        item.checked = false;
      });
    }
  })
</script>
<style lang="stylus">
  @media (min-width:1280px)
    .mu-dialog.dialog-class
      width 1024px 
      max-width 1024px
  
  @media (max-width:1280px)
    .mu-dialog.dialog-class
      width 1024px 
      max-width 1024px
      height 600px
      max-height 600px
  
  .mu-dialog-actions
    min-height 0 !important
    padding 0px !important
  .modalList-add
    max-height 380px !important
    min-height 380px !important
  .touming
    position relative
  .touming::after
    content ' '
    position absolute
    left 0
    top 0
    display inline-block
    width 140px
    height 140px
    background-color #000
    opacity 0.5

  .hideImg
    display none
  .u-train-doc
    text-align center

  .modal-footer
    button
      border-radius 20px !important
  .train-plan-body
    padding 0 !important
    height 560px !important
  .train-plan-wrap
    position relative !important
    height 640px !important
</style>



// WEBPACK FOOTER //
// addMoreModal.vue?3ba9c5c4